import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Component that handles global authentication errors
 * Listens to auth:unauthorized events and redirects to login
 */
const AuthErrorHandler: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    const handleUnauthorized = (event: CustomEvent) => {
      // console.log(
      //   "🔐 AuthErrorHandler: Handling unauthorized event, redirecting to login"
      // );

      // Logout the user
      logout();

      // Redirect to login page using React Router
      navigate("/login", { replace: true });
    };

    // Listen for authentication error events
    // console.log(
    //   "🔐 AuthErrorHandler: Setting up event listener for auth:unauthorized"
    // );
    window.addEventListener(
      "auth:unauthorized",
      handleUnauthorized as EventListener
    );

    // Cleanup
    return () => {
      window.removeEventListener(
        "auth:unauthorized",
        handleUnauthorized as EventListener
      );
    };
  }, [navigate, logout]);

  // This component doesn't render anything
  return null;
};

export default AuthErrorHandler;
